import React, { useState, useEffect } from "react";
import { X, ChevronRight } from "lucide-react";
import SkillModal from "./SkillModal";
import Cities from "./Cities";
import Companies from "./Companies";
import { useDispatch, useSelector } from "react-redux";
import { RESET_SELECTED_FILTERS } from "../../../redux/actions/types";
import Institution from "./Institution";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";
import Experience from "./Experience";

const CATEGORIES = [
  { id: "skills", label: "Skills" },
  { id: "company", label: "Company" },
  { id: "college", label: "College" },
  { id: "location", label: "Location" },
  { id: "experience", label: "Experience" },
];

const ListofCategories = ({ isOpen, onClose, onApplyFilters }) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [skillModal, setSkillModal] = useState(false);
  const [companyModal, setCompanyModal] = useState(false);
  const [collegeModal, setCollegeModal] = useState(false);
  const [locationModal, setLocationModal] = useState(false);
  const [experienceModal, setExperienceModal] = useState(false);

  const recruiterFilters = useSelector((store) => store?.hallOfFame?.recruiterFilters);

  useEffect(() => {
    if (isOpen) {
      setShowModal(true);
      document.body.style.overflow = "hidden";
    } else {
      setTimeout(() => setShowModal(false), 300);
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!showModal && !isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-end justify-center transition-all duration-300 md:items-center ${isOpen ? "visible" : "invisible"
        }`}
    >
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0"
          }`}
        onClick={onClose}
      />

      {/* Modal Container */}
      <div
        style={{ backgroundImage: "linear-gradient(180deg, #0B2435 0%, #0E3653 100%)" }}
        className={`relative z-10 w-full max-h-[90vh] md:max-h-[85vh] overflow-y-auto md:w-[400px] text-white rounded-t-3xl md:rounded-2xl p-6 shadow-xl transition-all duration-300 transform ${isOpen ? "translate-y-0 opacity-100 scale-100" : "translate-y-full md:translate-y-10 opacity-0 md:scale-95"
          }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold text-white">Explore Candidates</h2>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-white/10 transition-colors"
          >
            <X size={24} className="text-gray-400" />
          </button>
        </div>

        {/* Search Bar */}
        {/* <div className="relative mb-6">
          <input
            type="text"
            placeholder="Search By Skill/ College/ Company"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-transparent border border-[#4B617A] rounded-lg py-3 px-4 pr-10 text-sm text-white placeholder-gray-400 focus:outline-none focus:border-blue-500"
          />
          <Search
            className="absolute right-3 top-1/2 -translate-y-1/2 text-white"
            size={20}
          />
        </div> */}

        {/* Categories List */}
        <div className="space-y-3 mb-6">
          {CATEGORIES.map((category) => (
            <button
              key={category.id}
              onClick={() => {
                if (category.id === "skills") {
                  Mixpanel.track(Constants.Mixpanel.RECRUITER_FILTER_DRAWER_SKILLS_CLICKED);
                  setSkillModal(true);
                } else if (category.id === "company") {
                  Mixpanel.track(Constants.Mixpanel.RECRUITER_FILTER_DRAWER_COMPANIES_CLICKED);
                  setCompanyModal(true);
                }
                else if (category.id === "college") {
                  Mixpanel.track(Constants.Mixpanel.RECRUITER_FILTER_DRAWER_INSTITUTIONS_CLICKED);
                  setCollegeModal(true);
                }
                else if (category.id === "location") {
                  Mixpanel.track(Constants.Mixpanel.RECRUITER_FILTER_DRAWER_CITIES_CLICKED);
                  setLocationModal(true);
                }
                else if (category.id === "experience") {
                  Mixpanel.track(Constants.Mixpanel.RECRUITER_FILTER_DRAWER_EXPERIENCE_CLICKED);
                  setExperienceModal(true);
                }
              }}
              className="w-full flex items-center justify-between bg-[#0E3653] hover:bg-[#133145] p-4 rounded-lg transition-colors group"
            >
              <span className="font-semibold text-white">{category.label}</span>
              <ChevronRight
                size={20}
                className="text-white group-hover:translate-x-1 transition-transform"
              />
            </button>
          ))}
        </div>

        {/* Checkbox */}
        {/* <div className="mb-6">
          <label className="flex items-center space-x-3 cursor-pointer group select-none">
            <div
              className={`w-5 h-5 rounded border flex items-center justify-center transition-colors ${
                activelyLooking
                  ? "bg-[#2D4F71] border-[#2D4F71]"
                  : "bg-transparent border-gray-500 group-hover:border-gray-400"
              }`}
              onClick={() => setActivelyLooking(!activelyLooking)}
            >
              {activelyLooking && <Check size={14} className="text-white" />}
            </div>
            <span 
                className="text-white text-base"
                onClick={() => setActivelyLooking(!activelyLooking)}
            >
                Actively Looking Only
            </span>
          </label>
        </div> */}

        {/* Clear Filters Button */}
        <button
          onClick={() => {
            setSearchTerm("");
            Mixpanel.track(Constants.Mixpanel.RECRUITER_FILTER_DRAWER_CLEAR_FILTERS_CLICKED);
            dispatch({ type: RESET_SELECTED_FILTERS });
            onClose();
          }}
          className="w-full bg-[#1A3855] hover:bg-[#234668] text-[#5B8FB9] font-semibold py-3 rounded-lg transition-colors"
        >
          Clear Filters
        </button>
      </div>
      <SkillModal isOpen={skillModal} onCloseAll={() => {
        setSkillModal(false)
        onClose();
      }}
      onClose={() => setSkillModal(false)}
       skills={recruiterFilters?.skills} onApplyFilters={onApplyFilters} />
      <Companies isOpen={companyModal} onCloseAll={() => {
        setCompanyModal(false)
        onClose();
      }}
      onClose={() => setCompanyModal(false)}
      recruiterFilters={recruiterFilters?.companies} onApplyFilters={onApplyFilters} />
      <Cities isOpen={locationModal} onCloseAll={() => {
        setLocationModal(false)
        onClose();
      }}
      onClose={() => setLocationModal(false)} onApplyFilters={onApplyFilters} />
      <Institution isOpen={collegeModal} onCloseAll={() => {
        setCollegeModal(false)
        onClose();
      }} onClose={() => setCollegeModal(false)} onApplyFilters={onApplyFilters} />
      <Experience isOpen={experienceModal} onCloseAll={() => {
        setExperienceModal(false)
        onClose();
      }} onClose={() => setExperienceModal(false)} onApplyFilters={onApplyFilters} />
    </div>
  );
};

export default ListofCategories;
